module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var applicant = Util.clone(value); 
    ; __append("\n\n")
    ;  if (applicant.person) { 
    ; __append("\n<div>\n	")
    ; __append( card.render("Person", {value: applicant.person, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n")
    ;  if (applicant.address && (mode == "foreign" || !Util.Object.senseless(applicant.address))) { 
    ; __append("\n<div>\n	<b>Адрес:</b>\n	")
    ; __append( card.render("Address", {value: applicant.address, mode: mode}) )
    ; __append("\n</div>\n")
    ;  } 
    ; __append("\n")
  }
  return __output.join("");

}